import {
  GiftCardAddonOnlineResponse,
  GiftCardWebViewResponse,
} from '@ancon/wildcat-types'

import api from '../../../api'
import createAppAsyncThunk from '../../../store/createAppAsyncThunk'
import serializeError from '../../../store/utils/serializeError'
import getGiftCardAddonTenantOutletQueryParams from '../utils/getGiftCardAddonTenantOutletQueryParams'

export const fetchGiftCardWebView = createAppAsyncThunk<
  GiftCardWebViewResponse,
  { giftCardShareKey: string }
>('giftCards/fetchGiftCardWebView', async ({ giftCardShareKey }) => {
  try {
    const response = await api.card.giftCards.get.giftCardWebView({
      giftCardShareKey,
    })
    return response.data
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err)
    throw err
  }
})

/**
 * Fetches the gift card addon details for a given outlet slug.
 * This will give error for following cases:
 * - If the gift card addon integration is deactivated
 * - If outlet has no gift card system product
 * - If the outlet slug is not belongs to the white-label tenants/outlets
 */
export const fetchGiftCardAddon = createAppAsyncThunk<
  GiftCardAddonOnlineResponse,
  {
    outletSlug: string
    isServerSide?: boolean
  }
>(
  'giftCards/fetchGiftCardAddon',
  async ({ outletSlug, isServerSide }, { rejectWithValue }) => {
    const baseURL = isServerSide
      ? process.env.INTERNAL_INTEGRATION_API_URL
      : undefined

    const queryParams = getGiftCardAddonTenantOutletQueryParams()

    try {
      const response = await api.integration.giftCardAddon.get.giftCardAddon(
        {
          urlSlug: outletSlug,
          ...queryParams,
        },
        undefined,
        { baseURL },
      )
      return response.data
    } catch (error) {
      return rejectWithValue(serializeError(error))
    }
  },
)
